import * as React from 'react';

import BarChart16 from './BarChart16';

export const barChart16 = () => <BarChart16 />;

export default {
    title: 'Icon/Fill/BarChart16',
    component: BarChart16,
    parameters: {
        notes: "`import BarChart16 from 'box-ui-elements/es/icon/fill/BarChart16';`",
    },
};
